import type { FaireProductEntity } from "../../entity_types/product";

export const p_jmg34ga6xd: FaireProductEntity = {
  token: "p_jmg34ga6xd",
  type: "product",
  name: "Ceramic Vase Stripe 18x18cm – Orange - Home Decor",
  brandToken: "b_4qm8pqu56k",
  brandName: "Wildflowers by Floriette",
  imageUrl: "https://cdn.faire.com/fastly/19a49b64857e3f66e38aa78c2c38b3d2fbb56361f5c94c75d22d5102f8870b03.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/17958a99f57254414c244172de0323aae89a6081634b11f15d411328277fff7b.jpeg",
    "https://cdn.faire.com/fastly/5305ff83af0598f5975fe92aabcb7bfc3a01b0cd9e43316a2f9a7b86a858c256.jpeg"
  ],
  priceDollars: 3.7,
  description: "Ceramic Vase Stripe 18x18cm – Orange - Home Decor\n\nAdd warmth and character to any interior with the Ceramic Vase Stripe 18x18cm – Orange. Featuring a contemporary striped design in warm orange tones, this decorative ceramic vase brings a fresh Mediterranean-inspired look to home décor, retail displays and seasonal styling.\n\nIts timeless shape and vibrant colour make this vase a versatile home decor piece, perfect for displaying dried flowers, artificial flowers or decorative branches. Whether styled as a standalone statement or combined with floral arrangements, it creates a warm and inviting atmosphere that complements modern, bohemian and rustic interiors alike.\n\nIdeal for home décor stores, florists, concept stores and gift shops, this ceramic vase is easy to combine with a wide range of floral collections and decorative accessories. Its eye-catching striped finish makes it a beautiful addition to shelves, coffee tables, dining tables and window displays.\n\nDimensions:\n\n * Height: approximately 18 cm (7.1 in) \n * Diameter: approximately 18 cm (7.1 in) \nPlease note: this ceramic vase is designed for decorative purposes and is not waterproof. It is recommended for use with dried flowers, artificial flowers or decorative branches only.",
  tags: [],
  msrpDollars: 7.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:57.203Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
